export default class UserInquiryType {
    public id: number;
    public key: string;
    public descriptions: any;

    constructor(
        id: number,
        key: string,
        descriptions: any,
    ) {
        this.id = id;
        this.key = key;
        this.descriptions = descriptions;
    }

    get iconClass(): string {
        let icon = 'fa-toolbox';

        switch (this.key) {
            case 'questions':
                icon = 'fa-question-circle';
                break;
            case 'feedback':
                icon = 'fa-megaphone';
                break;
        }

        return icon;
    }

    get iconWrapperClass(): string {
        let iconWrapper = 'home-assistant-icon-defect';

        switch (this.key) {
            case 'questions':
                iconWrapper = 'home-assistant-icon-question';
                break;
            case 'feedback':
                iconWrapper = 'home-assistant-icon-feedback';
                break;
        }

        return iconWrapper;
    }

    public title(languageId: number) {
        const localizedDescription = this.descriptions.find((description: any) => description.languageId === languageId);
        return typeof localizedDescription !== 'undefined' ? localizedDescription.description : this.descriptions[0].description;
    }
}

